const currentCountry = process.env.NEXT_PUBLIC_COUNTRY || 'TW';

const availableLocales = {
  TW: ['en-tw', 'zh-tw'],
  // TODO: extend here to add other countries with their locales here
};

const defaultLocale = {
  TW: 'zh-tw',
  // TODO: extend here to add other countries with their locale here
};

const convertLocale = (lowerLocale) => {
  if (lowerLocale === 'en-tw') {
    return 'en';
  }

  if (lowerLocale.length === 2) return lowerLocale;
  const [lang, region] = lowerLocale.split('-');
  return `${lang}-${region.toUpperCase()}`;
};

const getPath = (lang, ns) => {
  if (ns === `commonEn`) {
    // hack to load english translations for tracking events label
    return import(`./locales/en.json`);
  }
  return import(`./locales/${convertLocale(lang)}.json`);
};

module.exports = {
  locales: availableLocales[currentCountry],
  defaultLocale: defaultLocale[currentCountry],
  loadLocaleFrom: (lang, ns) => {
    return getPath(lang, ns).then((m) => m.default);
  },
  pages: {
    '*': ['common', 'errors', 'commonEn'],
    '/ship/[[...slug]]': ['countries'],
    '/checkout': ['hk', 'countries'],
  },
};
